export default __webpack_public_path__ + "static/media/nav-calendar-red.22a4d1da.svg";